import { render } from "./ForgotPassword.vue?vue&type=template&id=0273a9ee"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"

import "./ForgotPassword.vue?vue&type=style&index=0&id=0273a9ee&lang=scss"
script.render = render

export default script